import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { PacchettoItem } from 'src/app/_classi/PacchettoItem';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';

@Component({
  selector: 'app-dettaglio-pacchetto',
  templateUrl: './dettaglio-pacchetto.component.html',
  styleUrls: ['./dettaglio-pacchetto.component.css']
})
export class DettaglioPacchettoComponent {

  get isMobile() {
    return this.appoggioService.getFromMobile();
  }

  @Input() pacchetto: PacchettoItem;
  @Input() codiceForm: any;
  @Input() linguaCorrente: any;
  @Input() canBack: any;
  @Input() idx: any;
  @Input() pacchettoSelezionato: any;
  @Input() fromBase: boolean;

  @Output() goBack = new EventEmitter<any>();
  @Output() selezionaPacchetto = new EventEmitter<any>();

  showLastStep = false;

  constructor(
    private messageService: MessageServiceService,
    private appoggioService: AppoggioService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.pacchettoSelezionato && this.fromBase) {
      this.scrollTO('box__scroll', 100)
    }
  }

  ngOnInit(): void {

  }

  emitSelezionaPacchetto(pacchetto): void {
    const obj = {
      pacchetto: pacchetto,
      idx: this.pacchetto.id
    }
    this.selezionaPacchetto.emit(obj);
  }

  tornaIndietro() {
    this.goBack.emit();
  }

  goToLast() {
    this.showLastStep = true;
    this.scrollTO('last_step', 500);
  }

  scrollTO(target, time) {
    setTimeout(() => {
      document.getElementById(target).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, time);
  }
}
